import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

var store = new Vuex.Store({
    state: {
        isShow: false,
        res_count: 0,
        menuList: [],
        userInfo: null,
        users: [],
        orgs: [],
        num:0,
        approvalNum:0,
        title: '',
        roleTitle:'',
        orgOne: null,
        socket: null,
        logout: false,
        otherLogout: false,
        authorId:"",
        random:0,
        showFlowCanvasNode: false, // 流程图canvas选择节点
        showFlowCanvasDialog: false, // 流程图canvas操作弹框
        showFlowCanvasDelete: false, // 流程图canvas删除弹框
        formFreestyle:false,//弹窗for form
        formula:false,//计算公式,
        associated:false,//指定关联表单
        editOption:false,//批量编辑
        oaFormItem:{},
        JsonString: {}, // 用于保存流程数据，方便详情渲染页面
        changeOrg:false,//部门是否调整，每次调整取反
        changeDrag:false,//每次取反，只是为了改变拖拽组件内的状态
        noticeClassify:false,//每次取反，只是为了改变公告分类的新数据
        msgNum:0
    },
    actions,
    mutations,
    getters
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js